import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function formatPrice(price: number, currency: string = "EUR"): string {
  return new Intl.NumberFormat("it-IT", {
    style: "currency",
    currency,
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(price);
}

export function getArtworkTitle(artwork: { title_it: string; title_en: string }, locale: string): string {
  void locale;
  return artwork.title_en || artwork.title_it;
}

export function getArtworkDescription(
  artwork: { description_it: string | null; description_en: string | null },
  locale: string
): string | null {
  return locale === "it" ? artwork.description_it : artwork.description_en;
}
